<template>
    <!-- This component doesn't render anything visible -->
</template>

<script setup>
import { watch, onMounted } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { useNotifications } from '@/composables/useNotifications';

const page = usePage();
const { success, error, warning, info } = useNotifications();

// Watch for flash messages from Laravel
watch(() => page.props.flash, (flash) => {
    if (flash) {
        if (flash.success) {
            success(flash.success);
        }
        if (flash.error) {
            error(flash.error);
        }
        if (flash.warning) {
            warning(flash.warning);
        }
        if (flash.info) {
            info(flash.info);
        }
        if (flash.message) {
            info(flash.message);
        }
    }
}, { deep: true, immediate: true });

// Handle initial flash messages on page load
onMounted(() => {
    const flash = page.props.flash;
    if (flash) {
        if (flash.success) {
            success(flash.success);
        }
        if (flash.error) {
            error(flash.error);
        }
        if (flash.warning) {
            warning(flash.warning);
        }
        if (flash.info) {
            info(flash.info);
        }
        if (flash.message) {
            info(flash.message);
        }
    }
});
</script>
